import React from 'react';
import { isStatusChange, } from 'src/Utils/types/ticketAudit';
import { Bold, ChangeLogContent, DateText, ChangeLogHeader, ChangesGroup, StatusChangeBadges, } from './styles';
import dayjs from 'dayjs';
import { StatusBadge } from 'src/Components/TicketsTable/components';
import { ArrowRightNarrow } from 'src/assets/Images';
var StatusChangeLog = function (_a) {
    var change = _a.change;
    return (React.createElement("div", null,
        change.message,
        React.createElement(StatusChangeBadges, null,
            React.createElement(StatusBadge, { status: change.previous_status }),
            React.createElement("img", { src: ArrowRightNarrow, alt: "Flecha hacia la derecha" }),
            React.createElement(StatusBadge, { status: change.new_status }))));
};
export default function AuditLog(_a) {
    var audit = _a.audit;
    var content = (React.createElement(ChangesGroup, null, audit.changes.map(function (change) {
        return isStatusChange(change) ? (React.createElement(StatusChangeLog, { key: change.type, change: change })) : (React.createElement("span", { key: change.message }, change.message));
    })));
    return (React.createElement("div", null,
        React.createElement(ChangeLogHeader, null,
            React.createElement(Bold, null,
                audit.performed_by.full_name,
                audit.performed_by.type === 'Contact' && ' (cliente)')),
        React.createElement(ChangeLogContent, null, content),
        React.createElement(DateText, null, dayjs(audit.created_at).format('DD/MM/YY hh:mm a'))));
}
